import { IntlShape } from 'react-intl'
import { create, enforce, group, omitWhen, test } from 'vest'
import type {
  BuyTogetherBenefit,
  BuyTogetherTrigger,
} from '../../../../../typings'
import { messages } from '../messages'

export function suite(intl: IntlShape, benefit?: BuyTogetherBenefit) {
  return create((config: BuyTogetherTrigger) => {
    const { $t } = intl
    const { validation } = messages
    const { discount: discountSkusToBuy, skus: skusToBuy, minQuantity } = config

    group('trigger', () => {
      test(`skus`, $t(validation.selectAnOption), () => {
        enforce(skusToBuy.length).gt(0)
      })

      test(`minQuantity`, $t(validation.greaterThan, { value: 0 }), () => {
        enforce(minQuantity).gt(0)
      })

      test(`discount`, $t(validation.greaterThanOrEquals, { value: 0 }), () => {
        enforce(discountSkusToBuy).gte(0)
      })

      test(`discount`, $t(validation.maxValue, { value: 100 }), () => {
        enforce(discountSkusToBuy).lte(100)
      })

      omitWhen(!benefit, () => {
        test('skus', $t(validation.repeatedSkus), () => {
          const skusToBuyIds = skusToBuy.map(({ id }) => id)
          const skusToGet = benefit!.skus

          enforce(
            skusToGet.find((skuToGet) => skusToBuyIds.includes(skuToGet.id))
          ).isFalsy()
        })
      })

      omitWhen(!benefit, () => {
        test(`discount`, $t(validation.discountNotZero), () => {
          const discountSkusToGet = benefit!.discount
          enforce(discountSkusToBuy + discountSkusToGet).gt(0)
        })
      })
    })
  })
}
